import LinkedUserInput from './linked-user-input';

export default LinkedUserInput;
